var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinallocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0002 22.1011L12.5842 21.6331C12.3242 21.3731 6.24023 14.1971 6.24023 9.88109C6.24023 6.13709 9.25623 3.12109 13.0002 3.12109C16.7442 3.12109 19.7602 6.13709 19.7602 9.88109C19.7602 14.1971 13.6762 21.3731 13.4162 21.6851L13.0002 22.1011ZM13.0002 4.16109C9.82823 4.16109 7.28023 6.70909 7.28023 9.88109C7.28023 13.2091 11.6482 18.8251 13.0002 20.4891C14.3522 18.8251 18.7202 13.2091 18.7202 9.88109C18.7202 6.70909 16.1722 4.16109 13.0002 4.16109Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 12.4812C11.5439 12.4812 10.3999 11.3372 10.3999 9.88125C10.3999 8.42525 11.5439 7.28125 12.9999 7.28125C14.4559 7.28125 15.5999 8.42525 15.5999 9.88125C15.5999 11.3372 14.4559 12.4812 12.9999 12.4812ZM12.9999 8.32125C12.1159 8.32125 11.4399 8.99725 11.4399 9.88125C11.4399 10.7652 12.1159 11.4412 12.9999 11.4412C13.8839 11.4412 14.5599 10.7652 14.5599 9.88125C14.5599 8.99725 13.8839 8.32125 12.9999 8.32125Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinallocation);
export default __webpack_public_path__ + "static/media/finallocation.fa7f3c514e51fc02fc71ac88925776a9.svg";
export { ForwardRef as ReactComponent };